import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio"];

  handleClick() {
    console.log('clicked')
    this.radioTarget.click();
  }
}
